import {findAllIn} from '@elements/dom-utils';

export function init() {
    let checkThreeSixtyConsent = setInterval(function(){
        let consent = _config.threeSixtyConsentGiven;
        if(consent) {
            initThreeSixty(true);
            clearInterval(checkThreeSixtyConsent);
        }
    }, 250)

    function initThreeSixty(cookieAccepted) {
        let viewers = findAllIn('.js-threesixty-viewer', document);
        viewers.map(function (viewer) {
            import('photo-sphere-viewer').then(function () {
                let id = viewer.id;
                let imgPath = viewer.getAttribute("data-img-path");
                let caption = viewer.getAttribute("data-caption");

                let sphere = new PhotoSphereViewer.Viewer({
                    container: id,
                    panorama: imgPath,
                    loadingImg: 'https://photo-sphere-viewer.js.org/assets/photosphere-logo.gif', //optional animated loading gif
                    caption: caption
                });
            });
        });
    }
}

function createViewer(viewerContainer, id, imgPath, caption) {

}
